import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { BookOutline } from '@vicons/ionicons5';
import { renderIcon } from '@/utils/index';

const routeName = 'knowledge';
const IFrame = () => import('@/views/iframe/index.vue');

// "Knowledge" single-level menu item — opens the PCT User Guide (served from /public)
// inside an iframe. To update the guide, replace public/PCT_User_Guide.html.
const routes: Array<RouteRecordRaw> = [
  {
    path: '/knowledge',
    name: routeName,
    redirect: '/knowledge/index',
    component: Layout,
    meta: {
      title: 'Knowledge',
      icon: renderIcon(BookOutline),
      sort: 8.5,
      isRoot: true,
      activeMenu: 'knowledge_index',
      alwaysShow: true,
    },
    children: [
      {
        path: 'index',
        name: 'knowledge_index',
        meta: {
          title: 'Knowledge',
          icon: renderIcon(BookOutline),
          affix: true,
          hidden: true,
          // bump ?v= whenever public/PCT_User_Guide.html is updated, to bypass the browser cache
          frameSrc: '/PCT_User_Guide.html?v=5',
        },
        component: IFrame,
      },
    ],
  },
];

export default routes;
